const defaultToKey = (...args) => args.map(arg => JSON.stringify(arg)).join('|');
const defaultCheckForceUpdate = () => false;
export const memoize = (func, config) => {
    var _a, _b;
    const configuration = {
        toKey: (_a = config === null || config === void 0 ? void 0 : config.toKey) !== null && _a !== void 0 ? _a : defaultToKey,
        checkForceUpdate: (_b = config === null || config === void 0 ? void 0 : config.checkForceUpdate) !== null && _b !== void 0 ? _b : defaultCheckForceUpdate,
    };
    const cache = new Map();
    return (...args) => {
        const argStringified = configuration.toKey(...args);
        if (!configuration.checkForceUpdate(...args) && cache.has(argStringified)) {
            return cache.get(argStringified);
        }
        cache.set(argStringified, func.apply(this, args));
        return cache.get(argStringified);
    };
};
export const asyncMemoize = (func, config) => {
    var _a, _b;
    const configuration = {
        toKey: (_a = config === null || config === void 0 ? void 0 : config.toKey) !== null && _a !== void 0 ? _a : defaultToKey,
        checkForceUpdate: (_b = config === null || config === void 0 ? void 0 : config.checkForceUpdate) !== null && _b !== void 0 ? _b : defaultCheckForceUpdate,
    };
    const cache = new Map();
    return async (...args) => {
        const argStringified = configuration.toKey(...args);
        if (!configuration.checkForceUpdate(...args) && cache.has(argStringified)) {
            return cache.get(argStringified);
        }
        cache.set(argStringified, await func.apply(this, args));
        return cache.get(argStringified);
    };
};
